import { useNavigate } from "react-router-dom";
import Services from "@/components/Services";
import { useServices } from "@/lib/useServices";
import { useSeason } from "@/lib/season";

export default function ServicesPage() {
  const { season } = useSeason();
  const services = useServices();
  const navigate = useNavigate();

  return (
    <Services
      season={season}
      services={services}
      onBook={(name) => navigate(`/schedule?service=${encodeURIComponent(name)}`)}
    />
  );
}
